
<template>
  <div class="page">
    <div class="page_header">
      <div style="height: 100%">
              <div class="example-wrapper">
                  <div class="example-header">
                    <h4>Testing Report <button style="margin-right: 0px; background-color: green; color: white;"
                            v-on:click="onBtnExport()">Export CSV</button>
                    </h4>
                    <div>
                        <table>
                          <tr>
                            <th>Actual</th>
                            <th>Still</th>
                            <th>Random-1</th>
                            <th>Random-2</th>
                            <th>Final Passed</th>
                          </tr>
                          <tr>
                            <td>{{ aaPassed }}</td>
                            <td>{{ stillPassed }}</td>
                            <td>{{ random1Passed }}</td>
                            <td>{{ random2Passed }}</td>
                            <td>{{ finalPassed }}</td>
                          </tr>
                        </table>
                    </div>
                  </div>
                  <ag-grid-vue
                    style="width: 100%; height: 900px;"
                    class="ag-theme-alpine"
                    :columnDefs="columnDefs"
                    @grid-ready="onGridReady"
                    :defaultColDef="defaultColDef"
                    :rowSelection="rowSelection"
                    :rowData="rowData"
                    :enableRangeSelection="true"
                    :copyHeadersToClipboard="true"
                    @selection-changed="onSelectionChanged">
                  </ag-grid-vue>
              </div>
        </div>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import api from '../api.js';
export default {
  name: "App",
  components: {
    'ag-grid-vue': AgGridVue
  },
  data: function () {
    return {
      columnDefs: [
        { field: 'video_id', filter: 'agNumberColumnFilter' },
        { field: 'type'},
        { field: 'tenant_id', filter: 'agNumberColumnFilter' },
        { field: 'score', filter: 'agNumberColumnFilter' },
        { field: 'test_with', filter: 'agNumberColumnFilter' },
        { field: 'scoring_logic', filter: 'agNumberColumnFilter' },
        { field: 'time_taken', filter: 'agNumberColumnFilter' },
        { field: 'last_tested', filter: 'agDateColumnFilter', filterParams: filterParams,},
        { field: 'session_id'}
      ],
      gridApi: null,
      columnApi: null,
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        minWidth: 100,
        flex: 1,
      },
      rowData: null,
      finalPassed: 0,
      aaPassed:0,
      stillPassed:0,
      random1Passed:0,
      random2Passed:0
    };
  },
  methods: {
      onSelectionChanged() {
        var selectedRows = this.gridApi.getSelectedRows();
        var selectedRowsString = '';
        var maxToShow = 5;
        selectedRows.forEach(function (selectedRow, index) {
          if (index >= maxToShow) {
            return;
          }
          if (index > 0) {
            selectedRowsString += ', ';
          }
          selectedRowsString += selectedRow.video_id;
        });
        if (selectedRows.length > maxToShow) {
          var othersCount = selectedRows.length - maxToShow;
          selectedRowsString +=
            ' and ' + othersCount + ' other' + (othersCount !== 1 ? 's' : '');
        }
        document.querySelector('#selectedRows').innerHTML = selectedRowsString;
      },
      onBtnExport() {
        this.gridApi.exportDataAsCsv();
      },
      async checkPassFail() {
        if (this.rowData.length > 0) {
            console.log("Inside check pass and failed");
            const aaPassed = this.rowData.filter(function(obj) { 
              return parseInt(obj.score) >= 90 && obj.type == 'actual';
            }).map(function (video) {
              return video.video_id;
            });
            const stillPassed = this.rowData.filter(function(obj) { 
              return parseInt(obj.score) <= 10 && obj.type == 'still';
            }).map(function (video) {
              return video.video_id;
            });
            const random1Passed = this.rowData.filter(function(obj) { 
              return parseInt(obj.score) <= 40 && obj.type == 'random1';
            }).map(function (video) {
              return video.video_id;
            });
            const random2Passed = this.rowData.filter(function(obj) { 
              return parseInt(obj.score) <= 40 && obj.type == 'random2';
            }).map(function (video) {
              return video.video_id;
            });
            const individualPassed = [aaPassed, stillPassed, random1Passed, random2Passed]
            const result = individualPassed.reduce((a, b) => a.filter(c => b.includes(c)));
            this.finalPassed = [... new Set(result)].length;
            this.aaPassed = aaPassed.length;
            this.stillPassed = stillPassed.length;
            this.random1Passed = random1Passed.length;
            this.random2Passed = random2Passed.length;
          }
      },
      async onGridReady(params, tenant_id) {
        if (params != undefined) {
          this.gridApi = params.api;
          this.gridColumnApi = params.columnApi; 
        }
        const updateData = (data) => {
          this.rowData = data;
        };
        let testingData = '';
        if(tenant_id != undefined) {
          try {
            testingData = await api.getAllTestingResult(tenant_id);
          } catch(error) {
            this.$bvToast.toast("Error", {
                  variant: "danger",
                });
          }
        }
        this.rowData = testingData;
        updateData(testingData);
        await this.checkPassFail();
      },
    },
    created() {
    this.rowSelection = 'multiple';
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
        if (mutation.type === "setSelectedTenant") {
            this.onGridReady(undefined, mutation.payload);
        }
      })
  },
  beforeDestroy() {
    this.unsubscribe();
  },
};

var filterParams = {
  comparator: (filterLocalDateAtMidnight, cellValue) => {
    var dateAsString = cellValue;
    if (dateAsString == null) return -1;
    var dateParts = dateAsString.split('/');
    var cellDate = new Date(
      Number(dateParts[2]),
      Number(dateParts[1]) - 1,
      Number(dateParts[0])
    );
    if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
      return 0;
    }
    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    }
    if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    }
    return 0;
  },
};
</script>
<style>
 @import "~ag-grid-community/styles/ag-grid.css";
 @import "~ag-grid-community/styles/ag-theme-alpine.css";
 table, tr, th, td{
  border:2px solid black;
  margin-top: 15px;
  padding: 10px;
  margin-right: 5%;
}
</style>